__turbopack_context__.v({
  "End": "ReviewSection-module-scss-module__CpRgtW__End",
  "IsDisabled": "ReviewSection-module-scss-module__CpRgtW__IsDisabled",
  "ReviewButtonNext": "ReviewSection-module-scss-module__CpRgtW__ReviewButtonNext",
  "ReviewButtonPrevious": "ReviewSection-module-scss-module__CpRgtW__ReviewButtonPrevious",
  "ReviewsWrapper": "ReviewSection-module-scss-module__CpRgtW__ReviewsWrapper",
  "Slide": "ReviewSection-module-scss-module__CpRgtW__Slide",
  "Swiper": "ReviewSection-module-scss-module__CpRgtW__Swiper",
});
